import React from 'react';
import { Helmet } from 'react-helmet-async';
import { COMPANY_INFO } from '../mock';

const FAQ_ITEMS_BEWERTUNGEN = [
  {
    question: 'Sind die Bewertungen echt?',
    answer: 'Ja. Wir zeigen ausschließlich Bewertungen von öffentlichen Plattformen wie Google und ProvenExpert. Keine erfundenen oder gefälschten Rückmeldungen.'
  },
  {
    question: 'Wo kann ich Bewertungen finden?',
    answer: 'Auf Google My Business und ProvenExpert. Die Links zu den Profilen werden in Kürze eingebunden.'
  },
  {
    question: 'Warum sind Bewertungen bei Gutachten wichtig?',
    answer: 'Sie geben einen Eindruck von Abläufen, Kommunikation und Zuverlässigkeit. Bei einem Unfallgutachten geht es um präzise Dokumentation – da hilft Orientierung durch Erfahrungen anderer.'
  },
  {
    question: 'Kann ich auch per WhatsApp Fragen stellen?',
    answer: 'Ja, selbstverständlich. Schreiben Sie uns über WhatsApp – wir antworten schnell und klären alle offenen Punkte.'
  },
  {
    question: 'Wie schnell bekommt man einen Termin?',
    answer: 'Meist innerhalb von 24–48 Stunden, je nach Region und Verfügbarkeit. Wir koordinieren das flexibel mit Ihnen.'
  },
  {
    question: 'Kommt ihr direkt vor Ort?',
    answer: 'Ja. Die Begutachtung erfolgt dort, wo sich Ihr Fahrzeug befindet – bundesweit. Sie müssen nicht zu uns fahren.'
  },
  {
    question: 'Was passiert nach der Begutachtung?',
    answer: 'Sie erhalten das fertige Gutachten zur Vorlage bei der Versicherung. Wir unterstützen Sie bei Fragen gerne weiter.'
  },
  {
    question: 'Kann ich vorher einen Eindruck bekommen?',
    answer: 'Rufen Sie uns an oder schreiben Sie per WhatsApp. Wir klären Ihre Fragen vorab und geben Ihnen eine erste Einschätzung.'
  }
];

export const SEOHeadBewertungen = () => {
  const schemaBreadcrumb = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite",
        "item": "https://www.dein-gutachten-direkt.de/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Bewertungen",
        "item": "https://www.dein-gutachten-direkt.de/bewertungen"
      }
    ]
  };

  const schemaFAQ = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FAQ_ITEMS_BEWERTUNGEN.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>Bewertungen & Erfahrungen | Dein Gutachten Direkt</title>
      <meta name="title" content="Bewertungen & Erfahrungen | Dein Gutachten Direkt" />
      <meta name="description" content="Echte Bewertungen aus öffentlichen Plattformen. Professionelle Unfallgutachten – bundesweit, unabhängig, direkt vor Ort." />
      <meta name="keywords" content="Bewertungen Unfallgutachten, Gutachter Bewertungen, Erfahrungen, Google Reviews, ProvenExpert" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.dein-gutachten-direkt.de/bewertungen" />
      <meta property="og:title" content="Bewertungen & Erfahrungen | Dein Gutachten Direkt" />
      <meta property="og:description" content="Echte Bewertungen aus öffentlichen Plattformen. Professionelle Unfallgutachten – bundesweit, unabhängig." />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://www.dein-gutachten-direkt.de/bewertungen" />
      <meta property="twitter:title" content="Bewertungen & Erfahrungen" />
      <meta property="twitter:description" content="Echte Bewertungen aus öffentlichen Plattformen" />

      {/* Canonical */}
      <link rel="canonical" href="https://www.dein-gutachten-direkt.de/bewertungen" />

      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify(schemaBreadcrumb)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(schemaFAQ)}
      </script>
    </Helmet>
  );
};
